const expatFont = {
  "header-font": ["DM Serif Display", "sans-serif"],
  ciutadella: ["Ciutadella Rounded", "sans-serif"],
  "sub-section-header-font": [
    "proxima-nova",
    "Helvetica",
    "Arial",
    "sans-serif",
  ],
  "proxima-nova": ["proxima-nova", "Helvetica", "Arial", "sans-serif"],
  "body-font": ["proxima-nova", "Helvetica", "Arial", "sans-serif"],
  opensans: ["Open Sans", "sans-serif"],
  "semibold-font": ["proxima-nova", "sans-serif"],
};

export default expatFont;
